var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"props":_vm.props,"clearable":"","disabled":_vm.disabled},on:{"change":_vm.handleChange},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }